import TableRowPerAction from "../../../../Components/Common/TableRowPerAction";
import TableData from "../../../../Components/Common/TableData";
import TableRow from "../../../../Components/Common/TableRow";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import { useAlert } from "../../../../Context/AlertContext";
import useSWRMutation from "swr/mutation";
import { sendDeleteRequestAuth } from "../../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../../hooks/useErrorToast";
import { UserApiUrls } from "../../../../Api/Auth/ApiUrls";
import { useAuth } from "../../../../Context/AuthContext";

function UserRow({ row, mutate, onEditClick }) {
  const { userData } = useAuth();
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    UserApiUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  // Define the function to call delete mutation with Alert Dialog
  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the user "${row.name}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger(row._id);
      }
    );
  };

  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row.name}</TableData>
        <TableData>{row.email}</TableData>
        <TableData>{row.organization}</TableData>
        <TableData>
          {row.roleId}
          {`${
            row.roleId === 0
              ? " (Super Admin)"
              : row.roleId === 1
              ? " (Admin)"
              : row.roleId === 2
              ? " (Student)"
              : row.roleId === 6
              ? " (Moderator)"
              : ""
          }`}
        </TableData>
        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>

        <TableRowPerAction
          onEdit={
            // ❌ Prevent editing if:
            // - userData.roleId = 6 AND row.roleId is 0 or 1
            // - OR both row.roleId & userData.roleId are 6
            (userData.roleId === 6 && [0, 1].includes(row.roleId)) ||
            (row.roleId === 6 && userData.roleId === 6)
              ? null
              : () => onEditClick(row)
          }
          onDelete={
            // ❌ Prevent delete if:
            // - userData.roleId = 6 AND row.roleId is 0 or 1
            // - OR both row.roleId & userData.roleId are 6
            // - OR user is trying to delete themselves
            (userData.roleId === 6 && [0, 1].includes(row.roleId)) ||
            (row.roleId === 6 && userData.roleId === 6) ||
            userData._id === row._id
              ? null
              : handleDelete
          }
        />
      </TableRow>
    </>
  );
}

export default UserRow;
